import { Button, Form } from '@heathmont/moon-core-tw';
import useTranslation from '~/client/hooks/i18n/useTranslation';
import Translate from '~/client/shared/i18n/Translate';
import CategoriesInput from './CategoriesInput';
import EmailInput from './EmailInput';
import FileUploader from './FileUploader';
import MessageInput from './MessageInput';
import useContactSupport from './useContactSupport';
import Modal from '@/external/components/Modal';
import ControlsCloseSmall from '@/external/icons/ControlsCloseSmall';

type Props = { showDialog: boolean; toggleDialog: () => void };

const EmailFormDialog: FC<Props> = ({ showDialog, toggleDialog }) => {
  const {
    required,
    getValues,
    onDrop,
    handleSubmit,
    loading,
    errors,
    categories,
  } = useContactSupport({ toggleDialog });

  return (
    <Modal open={showDialog}>
      <Modal.Backdrop onClose={toggleDialog} />
      <Modal.Panel className="max-w-[616px] bg-goku px-8 py-10">
        <div data-testid="email-popup" className="grid gap-4">
          <div>
            <Button
              className="relative bottom-7 left-4 float-right flex h-7 w-7"
              variant="ghost"
              iconRight={<ControlsCloseSmall className="relative right-1" />}
              onClick={toggleDialog}
            />
            <p className="text-moon-24 font-bold text-bulma">
              <Translate id="support.submit_help_request" />
            </p>
          </div>
          <p
            className="text-bulma"
            dangerouslySetInnerHTML={{
              __html: useTranslation('support.could_not_find_answer'),
            }}
          />
          <Form
            className="grid gap-4"
            onSubmit={handleSubmit}
            method="get"
            id="helpCenter"
          >
            <EmailInput
              {...required('email')}
              defaultValue={getValues().email}
              errors={!!errors?.email?.message}
            />
            <CategoriesInput
              {...required('topic')}
              categories={categories}
              errors={!!errors?.topic?.message}
            />
            <MessageInput
              {...required('message')}
              errors={!!errors?.message?.message}
            />
            <FileUploader onDrop={onDrop} />
            <Button
              className="relative m-auto w-24 items-center justify-center gap-2 px-4 py-2 font-headline text-moon-14"
              variant="primary"
              disabled={loading}
              type="submit"
              form="helpCenter"
              value="Submit"
              onClick={handleSubmit}
            >
              <Translate id="support.send" />
            </Button>
          </Form>
        </div>
      </Modal.Panel>
    </Modal>
  );
};

export default EmailFormDialog;
